import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import {
  AdminPermission,
  clearAdminSession,
  getDefaultAdminRoute,
  hasValidAdminSession,
  hasAdminPermission,
} from './adminPermissions';

interface IProps extends RouteProps {
  children: React.ReactNode;
  path: string;
  permission?: AdminPermission;
}

const PrivateRoute: React.FC<IProps> = ({
  children,
  path,
  permission,
  ...rest
}) => {
  return (
    <Route
      path={path}
      exact={true}
      render={({ location }) => {
        if (!hasValidAdminSession()) {
          clearAdminSession();
          return (
            <Redirect
              to={{
                pathname: '/login',
                state: { from: location },
              }}
            />
          );
        }

        if (permission && !hasAdminPermission(permission)) {
          return <Redirect to={{ pathname: getDefaultAdminRoute() }} />;
        }

        return children;
      }}
    />
  );
};

export default PrivateRoute;
